import React, { useState } from 'react'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import {
  Flex,
  Heading,
  HStack,
  Text,
  Divider,
  Box,
  IconButton,
} from '@chakra-ui/react'
import { Word } from '@/components/Card/Word'
import { useIsPhoneWidth } from '@/hooks/useIsMobile'
import { SwiperRow } from '@/components/SwiperRow'
import { getTrendingCardRenderer } from '@/components/Card/Word'
import type { Glossary } from '@/types/glossary'
import { useIsTabletWidth } from '@/hooks/useIsTablet'

interface Props {
  relatedWords: Glossary[]
}

const RelatedWordsSection = ({ relatedWords }: Props) => {
  const { t } = useTranslation()
  const [activeIndex, setActiveIndex] = useState(0)
  const [selectedWord, setSelectedWord] = useState<Glossary | null>(null)
  const isPhone = useIsPhoneWidth()
  const isTablet = useIsTabletWidth()
  const swiperStep = isPhone ? 1 : isTablet ? 2 : 3

  const handleSlidePrev = () => {
    //if (activeIndex < swiperStep) return
    let nextIndex = activeIndex - swiperStep
    nextIndex =
      nextIndex < 0
        ? relatedWords.length - (relatedWords.length % swiperStep)
        : nextIndex
    setActiveIndex(nextIndex)
  }

  const handleSlideNext = () => {
    //if (activeIndex + swiperStep >= MAX_INDEX) return
    let nextIndex = activeIndex + swiperStep
    nextIndex = nextIndex > relatedWords.length - 1 ? 0 : nextIndex
    setActiveIndex(nextIndex)
  }

  //const totalPage = Math.ceil(relatedWords.length / swiperStep)
  //const curPage = Math.floor(activeIndex / swiperStep) + 1

  return (
    <Flex
      mt={[40, null, 92, null]}
      flexDirection="column"
      alignItems="start"
      position={'relative'}
      overflow={'hidden'}
    >
      <Heading
        fontSize={[22, null, null, 32]}
        fontWeight={600}
        lineHeight={'135%'}
      >
        {t('article.relatedWords')}
      </Heading>
      <Box
        overflow={'hidden'}
        maxW={['100%', null, '695px', '1270.5px']}
        w={['100%', null, '695px', '1270.5px']}
        className={'trending-swiper-container'}
        mt={8}
      >
        <Flex flexDir={'column'}>
          <SwiperRow
            swiperStep={swiperStep}
            activeIndex={activeIndex}
            slides={relatedWords}
            selectedWord={selectedWord}
            setSelectedWord={setSelectedWord}
            renderer={getTrendingCardRenderer}
          />
        </Flex>
      </Box>
      <Box
        marginLeft={'auto'}
        position={'absolute'}
        right={['2%', null, null, '10%']}
        top={['85%', null, null, '90%']}
        zIndex={2}
      >
        <IconButton
          isDisabled={relatedWords.length > swiperStep ? false : true}
          aria-label="slide 3 prev cards"
          icon={<BsArrowLeft fontSize={'40px'} />}
          variant="unstyled"
          onClick={() => handleSlidePrev()}
        />

        <IconButton
          ml={12}
          isDisabled={relatedWords.length > swiperStep ? false : true}
          aria-label="slide 3 next cards"
          icon={<BsArrowRight fontSize={'40px'} />}
          variant="unstyled"
          onClick={() => handleSlideNext()}
        />
      </Box>
    </Flex>
  )
}

export default RelatedWordsSection
